const DIVISIONS = [
  { amount: 60, unit: "seconds" },
  { amount: 60, unit: "minutes" },
  { amount: 24, unit: "hours" },
  { amount: 7, unit: "days" },
  { amount: 4.34524, unit: "weeks" },
  { amount: 12, unit: "months" },
  { amount: Number.POSITIVE_INFINITY, unit: "years" },
];

/**
 * Human-friendly "x minutes/hours/days ago" for a past timestamp (ms since epoch). Uses
 * Intl.RelativeTimeFormat so the phrasing is localized and screen-reader friendly. Returns
 * "just now" for very recent times and "" for a missing/invalid timestamp.
 */
export default function formatRelativeTimeFromNow(timestampMs, now = Date.now()) {
  if (typeof timestampMs !== "number" || Number.isNaN(timestampMs)) return "";
  let duration = (timestampMs - now) / 1000; // seconds; negative = in the past
  if (Math.abs(duration) < 45) return "just now";
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  for (let i = 0; i < DIVISIONS.length; i += 1) {
    const division = DIVISIONS[i];
    if (Math.abs(duration) < division.amount) {
      return rtf.format(Math.round(duration), division.unit);
    }
    duration /= division.amount;
  }
  return "";
}
